import { render, staticRenderFns } from "./CartFooter.vue?vue&type=template&id=a6dd3298"
import script from "./CartFooter.vue?vue&type=script&lang=js"
export * from "./CartFooter.vue?vue&type=script&lang=js"
import style0 from "./CartFooter.vue?vue&type=style&index=0&id=a6dd3298&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports